import { CuiModal } from 'front-lib'
import { useAtom } from 'jotai'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'
import { BasicsSection } from 'src/pages/coreUx/onboarding/components/BasicsSection'

export function UserOnboardingModal() {
  const [{ isOpen }, setUserOnboardingModal] = useAtom(userOnboardingModalAtom)

  return (
    <CuiModal
      isOpen={isOpen}
      onRequestClose={() => setUserOnboardingModal({ isOpen: false })}
      withCloseIcon
      data-testid="user-onboarding-modal"
      className="user-onboarding-modal">
      <BasicsSection />
    </CuiModal>
  )
}
